// Italian, Dutch and German storefront strings (machine-translated from English, then reviewed for placeholders).
const MORE = {
 "it": {
  "deliveryFee": "Consegna",
  "discount": "Sconto",
  "total": "Totale",
  "continue": "Continua",
  "back": "Indietro",
  "backHome": "Torna a Fleurinelle",
  "paymentNote": "I dati della carta non transitano mai sui server di Fleurinelle. Il pagamento è gestito da Stripe.",
  "track": "Segui il tuo ordine",
  "orderNumber": "Numero ordine",
  "trackNow": "Visualizza ordine",
  "somethingWrong": "Si è verificato un problema",
  "thankYou": "Grazie. Il suo ordine è confermato.",
  "whatHappensNext": "Cosa succede adesso",
  "viewOrder": "Visualizza ordine",
  "currency": "Valuta",
  "language": "Lingua",
  "sentFrom": "Inviato da",
  "to": "a",
  "readMore": "Scopri di più",
  "all": "Tutti",
  "loading": "Caricamento",
  "yearsInBusiness": "Anni di attività",
  "writeReview": "Lascia una recensione",
  "corridorCities": "Città in cui consegniamo",
  "paymentMethods": "Metodi di pagamento accettati",
  "company": "Azienda",
  "legal": "Note legali e affidabilità",
  "support": "Assistenza WhatsApp",
  "becomePartner": "Diventa nostro partner",
  "becomeDriver": "Diventa corriere",
  "contact": "Contatti",
  "careers": "Lavora con noi",
  "terms": "Termini di servizio",
  "privacy": "Informativa sulla privacy",
  "cookies": "Informativa sui cookie",
  "refundPolicy": "Politica di rimborso",
  "guarantee": "Garanzia di consegna",
  "howItWorksLink": "Come funziona",
  "cutoffIn": "Ordina entro",
  "forDeliveryToday": "per la consegna oggi a",
  "closed": "La consegna in giornata non è disponibile per oggi. La prossima data di consegna è già preselezionata.",
  "noResults": "Nessun risultato per questa ricerca.",
  "occasionEtiquette": "Una nota sull'etichetta",
  "seller": "Fleurinelle",
  "saveDate": "Ricordamelo l'anno prossimo",
  "from": "da",
  "zonesLabel": "zone di consegna",
  "deliversToday": "Consegna oggi",
  "closedToday": "Consegna il giorno successivo",
  "addToCart": "Aggiungi al carrello",
  "buyNow": "Procedi all'acquisto",
  "size": "Dimensione",
  "stems": "steli",
  "addOns": "Extra",
  "included": "Incluso",
  "deliveryDetails": "Consegna",
  "zone": "Zona di consegna",
  "date": "Data di consegna",
  "window": "Fascia oraria di consegna",
  "morning": "Mattina 09:00 – 13:00",
  "afternoon": "Pomeriggio 13:00 – 18:00",
  "evening": "Sera 18:00 – 21:00",
  "cardMessage": "Messaggio sul biglietto",
  "cardLanguage": "Lingua per la scrittura a mano",
  "suggestions": "Messaggi suggeriti",
  "senderName": "Il Suo nome come apparirà sul biglietto",
  "anonymous": "Anonimo, consegna a sorpresa",
  "substitution": "Politica di sostituzione",
  "relatedProducts": "Potrebbe piacerLe anche",
  "checkout": "Cassa",
  "stepRecipient": "Destinatario",
  "stepMessage": "Messaggio e orario",
  "stepPayment": "Pagamento",
  "stepConfirm": "Conferma",
  "fullName": "Nome e cognome del destinatario",
  "phone": "Telefono del destinatario",
  "whatsapp": "Numero WhatsApp (opzionale)",
  "address": "Indirizzo completo",
  "landmark": "Punto di riferimento più vicino o come trovare la porta",
  "landmarkHelp": "Gli indirizzi marocchini sono spesso descrittivi. Questo è il campo più utile di questa pagina.",
  "callBefore": "Chiama il destinatario prima della consegna",
  "callBeforeHelp": "Il tasso di successo più elevato.",
  "surprise": "Non chiamare, consegna a sorpresa",
  "surpriseHelp": "Se non c'è nessuno in casa, il nostro team chiamerà come misura di riserva e potrebbe essere necessaria una riconsegna.",
  "buyerEmail": "La Sua email",
  "buyerPhone": "Il Suo telefono",
  "country": "Il Suo paese",
  "payNow": "Paga in modo sicuro",
  "orderSummary": "Riepilogo dell'ordine",
  "subtotal": "Subtotale",
  "tagline": "Fiori consegnati a mano, ovunque in Marocco.",
  "heroTitle": "Ordinato dall'estero. Composto nella sua città. Fotografato alla sua porta.",
  "heroBody": "Realizzato questa mattina nella sua città marocchina, portato a mano alla sua porta in giornata — e una foto arriva nella tua casella di posta pochi minuti dopo che lei lo ha ricevuto.",
  "dealsTitle": "In offerta questa settimana",
  "dealsNote": "Promozioni Fleurinelle, fino a esaurimento steli",
  "deliverTo": "Consegna a",
  "on": "il",
  "forOccasion": "per",
  "findFlowers": "Trova i fiori",
  "chooseOccasion": "Scegli un'occasione",
  "occasions": "Occasioni",
  "flowers": "Fiori",
  "cities": "Città",
  "sameDay": "Stesso giorno",
  "about": "Chi siamo",
  "search": "Cerca",
  "cart": "Carrello",
  "deliveringToday": "Consegne oggi a",
  "orderBefore": "ordina entro le",
  "localTime": "ora locale",
  "proofTitle": "Sei lontano. Ecco cosa ricevi in cambio.",
  "proofBody": "Ogni consegna Fleurinelle si conclude con una fotografia scattata alla porta, con il nome della destinataria, la città e l'orario esatto di arrivo.",
  "deliveryProof": "Prova di consegna",
  "recipient": "Destinataria",
  "city": "Città",
  "deliveredAt": "Consegnato alle",
  "arrangedBy": "Composizione di",
  "shopByOccasion": "Acquista per occasione",
  "bestSellers": "I più venduti questa settimana",
  "howItWorks": "Come funziona",
  "shopByCity": "Acquista per città",
  "reviews": "Recensioni",
  "meetFlorists": "I nostri team",
  "guides": "Guide",
  "faq": "Domande frequenti",
  "step1Title": "Scegli il bouquet nella sua città",
  "step1Body": "Niente magazzini, niente intermediari. Ogni bouquet su questo sito è realizzato artigianalmente nella città della destinataria.",
  "step2Title": "Iniziamo in pochi minuti",
  "step2Body": "Non appena il pagamento è confermato, iniziamo a preparare la composizione nella città della destinataria. La finestra di consegna è fissata.",
  "step3Title": "Consegnato a mano e fotografato",
  "step3Body": "Ordina entro le 17:00 ora del Marocco (16:30 ad Agadir) per la consegna in giornata. La foto ti raggiunge pochi minuti dopo la consegna.",
  "trustPhoto": "Foto come prova di consegna",
  "trustSameDay": "Stesso giorno in cinque città",
  "trustVetted": "Realizzato localmente in Marocco",
  "trustRefund": "Rimborso completo se non riusciamo a consegnare",
  "reminderSaved": "Promemoria salvato.",
  "currentlyUnavailable": "Al momento non disponibile",
  "backOnDate": "Disponibile di nuovo il {date}",
  "backSoon": "Lo riporteremo presto in negozio — ripassi tra qualche giorno.",
  "restockAlertCta": "Avvisami",
  "restockEmailPlaceholder": "La sua email",
  "restockAlertHelp": "Una sola email nel momento in cui torna disponibile. Niente marketing, niente condivisioni.",
  "restockConfirm": "Le invieremo un'email non appena questo bouquet sarà di nuovo disponibile.",
  "restockAlreadyOn": "È già nella lista d'attesa per questo bouquet.",
  "chooseCity": "Scegli la città",
  "addressLine1": "Indirizzo (riga 1)",
  "addressLine2": "Indirizzo (riga 2)",
  "buildingApartment": "Edificio / appartamento",
  "addressLine1Placeholder": "Inizia a digitare la via…",
  "addressLine2Placeholder": "Punto di riferimento, via parallela (opzionale)",
  "buildingApartmentPlaceholder": "Nome edificio, piano, interno (opzionale)",
  "addressLine1Help": "Suggeriamo automaticamente indirizzi marocchini mentre digita — ne selezioni uno per velocizzare l'inserimento.",
  "howOften": "Con quale frequenza desidera ricevere questi fiori?",
  "oneOff": "Solo questa volta",
  "everyWeek": "Ogni settimana",
  "everyMonth": "Ogni mese",
  "everyYear": "Ogni anno",
  "ownDates": "Scelgo io le date",
  "pickDates": "Date di consegna",
  "addDate": "Aggiungi una data",
  "startPlan": "Avvia il piano",
  "planDiscount": "di sconto su ogni consegna con un piano ricorrente",
  "planPriceLocked": "Il suo prezzo è bloccato al prezzo odierno per tutta la durata del piano.",
  "planRouting": "Ogni consegna è gestita dal nostro team locale che copre quella zona nel giorno stabilito.",
  "recurringOff": "Le consegne ricorrenti si attivano non appena viene collegato un gateway di pagamento.",
  "mySubscriptions": "Consegne ricorrenti",
  "nextDelivery": "Prossima consegna",
  "skipNext": "Salta la prossima",
  "cancelPlan": "Annulla il piano",
  "manageBilling": "Gestisci la fatturazione",
  "deliveriesSent": "consegne effettuate",
  "endsAfterLast": "Termina automaticamente dopo l'ultima data.",
  "planCancelled": "Disdetta al termine del periodo corrente.",
  "cardSavedNote": "La sua carta è salvata e addebitata il giorno prima di ogni data selezionata.",
  "noSubscriptions": "Non ha ancora nessuna consegna ricorrente.",
  "addAnotherRecipient": "Aggiungi un altro destinatario a questo carrello",
  "basket": "Carrello",
  "giftFor": "Regalo",
  "removeGift": "Rimuovi",
  "savedRecipients": "Destinatari salvati",
  "useSaved": "Usa un destinatario salvato",
  "account": "Il mio account",
  "signIn": "Accedi",
  "signUp": "Crea un account",
  "signOut": "Esci",
  "myOrders": "I miei ordini",
  "myRecipients": "Destinatari",
  "myReminders": "Promemoria",
  "password": "Password",
  "createAccount": "Crea account",
  "forgotPassword": "Password dimenticata",
  "resetPassword": "Imposta una nuova password",
  "newPassword": "Nuova password",
  "confirmPassword": "Conferma la nuova password",
  "passwordsMismatch": "Le due password non corrispondono",
  "passwordUpdated": "La sua password è stata aggiornata",
  "saveRecipient": "Salva questo destinatario",
  "addReminder": "Aggiungi un promemoria",
  "remindMe": "Ricordamelo prima di",
  "leadDays": "giorni prima",
  "channels": "Invia tramite",
  "whatsappNumber": "Numero WhatsApp",
  "relationship": "Chi è (madre, sorella, amica)",
  "saved": "Salvato",
  "applyTitle": "Candidati per consegnare con Fleurinelle",
  "applyStatus": "La tua candidatura",
  "uploadDocuments": "Documenti",
  "submitApplication": "Invia candidatura",
  "shopName": "Nome del negozio",
  "ownerName": "Nome del titolare",
  "zonesCovered": "Zone che copri",
  "capacity": "Ordini che puoi gestire al giorno",
  "instagram": "Instagram (facoltativo)",
  "notes": "Qualcos'altro che dovremmo sapere",
  "applyCta": "Candidati come fiorista",
  "deliveriesInBasket": "composizioni in questo carrello",
  "createAccountPrompt": "Salva i tuoi destinatari e ricevi un promemoria discreto l'anno prossimo.",
  "emptyBasket": "Il tuo carrello è vuoto.",
  "accountBenefits": "Destinatari salvati, storico ordini e promemoria annuali.",
  "stepContact": "Contatto",
  "stepDelivery": "Consegna",
  "stepPay": "Pagamento",
  "contactTitle": "Dove inviamo gli aggiornamenti?",
  "contactHelp": "Mandiamo qui la ricevuta e la foto della consegna.",
  "deliveryTitle": "Chi riceve i fiori?",
  "payTitle": "Riepilogo e pagamento",
  "haveAccount": "Acceda per ritrovare i destinatari salvati e completare l'ordine più rapidamente",
  "returnToStore": "Torna al negozio",
  "editBasket": "Modifica il carrello",
  "showSummary": "Mostra riepilogo ordine",
  "hideSummary": "Nascondi riepilogo ordine",
  "addExtrasTitle": "Aggiunga qualcosa a questa consegna",
  "addExtrasHelp": "C'è ancora tempo — il suo bouquet non è ancora stato preparato. Scelga un extra e lo invieremo insieme ai fiori.",
  "addExtrasCta": "Aggiungi alla mia consegna",
  "addExtrasNote": "Pagato separatamente in un solo passaggio. Una volta che il fiorista inizia il bouquet, gli extra non sono più disponibili.",
  "extrasAdded": "Il suo extra è in viaggio con i fiori",
  "extrasPending": "Conferma del suo extra in corso…",
  "basketDone": "Fatto",
  "removeLine": "Rimuovi",
  "basketEmpty": "Il suo carrello è vuoto.",
  "continueShopping": "Sfoglia i bouquet",
  "couponQuestion": "Ha un codice sconto?",
  "couponPlaceholder": "Inserisca il codice",
  "tickFresh": "Fiori freschi di prima qualità",
  "tickHandTied": "Legati a mano da fioristi locali",
  "tickOnTime": "Consegnati nella finestra oraria scelta",
  "chargedEur": "Addebitato in EUR",
  "todaysRate": "al tasso di oggi",
  "deliveringTo": "Consegna a",
  "changeCity": "modifica",
  "couponRemove": "Rimuovi",
  "couponHint": "Digiti il codice, poi prema Applica.",
  "waQuestion": "Il destinatario usa WhatsApp su questo numero?",
  "yes": "Sì",
  "no": "No",
  "waNumberLabel": "Il loro numero WhatsApp",
  "addressQuestion": "Conosce l'indirizzo di consegna?",
  "addressKnown": "Sì, lo digito io",
  "addressUnknown": "No — chiedi al destinatario",
  "addressUnknownHelp": "Gli invieremo un link privato per indicare il suo punto esatto. Ci indichi il quartiere così il corriere può mettersi in moto.",
  "neighbourhoodRequired": "Aggiunga il quartiere o un punto di riferimento prima di pagare.",
  "shareTheLink": "Condividi il link",
  "callRequiredNote": "Chiameremo il destinatario per confermare l'indirizzo — una consegna a sorpresa non è possibile senza di esso.",
  "applyCode": "Applica",
  "giftCard": "Messaggio sul biglietto",
  "charsLeft": "caratteri rimanenti",
  "deliveryDate": "Data di consegna",
  "deliveryWindowLabel": "Fascia oraria",
  "trustSecure": "Pagamento crittografato",
  "trustFlorists": "Realizzato localmente in Marocco",
  "shareBody": "Condivida il suo link. Risparmieranno il 10% sul loro primo bouquet.",
  "upsellTitle": "Trasformalo in un rituale mensile",
  "upsellBody": "Stesso bouquet, stesso destinatario, ogni mese — {discount}% di sconto su ogni consegna e il prezzo bloccato da oggi.",
  "upsellCta": "Attiva un piano mensile",
  "upsellWeekly": "Rendilo settimanale",
  "upsellYearly": "Una volta all'anno",
  "createAccountTitle": "Tutto sotto controllo in un unico posto",
  "resumeExpired": "Il link di recupero è scaduto — il suo bouquet è ancora a un tocco di distanza.",
  "expressTitle": "Pagamento rapido",
  "expressOr": "oppure paga con carta",
  "expressNote": "{wallet} si apre sulla pagina sicura di {gateway} — nessun dato da inserire.",
  "expressNeedInfo": "Abbiamo prima bisogno del nome, del numero di telefono e dell'indirizzo del destinatario.",
  "expressLockedLabel": "Aggiungi i dettagli",
  "expressLockedNote": "Tocca per inserire i dati del destinatario che mancano ancora.",
  "accHeading": "Il mio account",
  "accBackStore": "Torna al negozio",
  "accFallbackTitle": "Account",
  "navOverview": "Panoramica",
  "navOrders": "I miei ordini",
  "navRecurring": "Consegne ricorrenti",
  "navWishlist": "Lista dei desideri",
  "navRecipients": "Destinatari",
  "navReminders": "Promemoria",
  "navProfile": "Profilo",
  "navPreferences": "Preferenze",
  "navBilling": "Indirizzo di fatturazione",
  "navSavedCards": "Carte salvate",
  "ovWelcome": "Bentornata",
  "ovLatestOrder": "Ultimo ordine",
  "ovViewOrder": "Visualizza ordine",
  "ovNoOrders": "Non ha ancora effettuato nessun ordine.",
  "ovStartShopping": "Inizia lo shopping",
  "ovNextReminder": "Prossimo promemoria",
  "ovManageReminders": "Gestisci i promemoria",
  "ovNoReminders": "Nessun promemoria impostato. La avviseremo prima di ogni data importante.",
  "ovAddReminder": "Aggiungi un promemoria",
  "wStatOrders": "ordini",
  "wStatWishlist": "articoli nella lista dei desideri",
  "wStatReminders": "promemoria",
  "wlEmpty": "La sua lista dei desideri è vuota. Tocca il cuore su qualsiasi bouquet per salvarlo qui.",
  "wlBrowse": "Sfoglia i bouquet",
  "wlUnavailable": "Temporaneamente non disponibile",
  "pfTitle": "Profilo",
  "pfFullName": "Nome completo",
  "pfEmail": "Email",
  "trustSubstitution": "Sostituzione gratuita con prodotto equivalente",
  "cutoffLead": "Ordina entro",
  "cutoffTail": "per la consegna oggi a {city}",
  "cutoffClosedLead": "Le consegne in giornata a {city} sono chiuse per oggi — il prossimo slot è domani mattina.",
  "requiredName": "Aggiunga il nome e cognome del destinatario",
  "requiredPhone": "Un numero di cellulare marocchino, es. +212 6 12 34 56 78",
  "requiredPhoneIntl": "Inserisca un numero di telefono valido per il prefisso selezionato",
  "requiredAddress": "Via, numero civico e interno affinché il nostro team possa trovare la porta",
  "moroccoOnly": "Consegna esclusivamente in Marocco",
  "mapSearchPlaceholder": "Cerca un indirizzo in Marocco…",
  "myPosition": "La mia posizione",
  "exactLocation": "Punto di consegna esatto",
  "pinOnMap": "Indica la posizione esatta",
  "pinHelp": "Aiuti il corriere a trovare la porta — cerchi l'indirizzo o trascini la rosa nel punto esatto.",
  "pinSet": "Segnaposto inserito",
  "askRecipient": "Non lo so — chiedi al destinatario",
  "askRecipientHelp": "Creeremo un link privato. Lo invii al destinatario; non appena condivide la sua posizione, verrà collegata a questo ordine.",
  "shareLink": "Condivida questo link con il destinatario",
  "copyLink": "Copia link",
  "copied": "Copiato",
  "locationReceived": "Posizione ricevuta",
  "optionalLabel": "Facoltativo",
  "deliverTitle": "Condivida la posizione di consegna",
  "deliverIntro": "Qualcuno le sta inviando dei fiori. Condivida la sua posizione esatta così il corriere consegnerà alla porta giusta.",
  "shareMyLocation": "Condividi la mia posizione",
  "deliverThanks": "Grazie! La sua posizione è ora collegata alla consegna.",
  "deliverAdjust": "Trascini la rosa per affinare il punto esatto.",
  "deliverExpired": "Questo link di posizione non è più valido.",
  "enableLocation": "Autorizzi l'accesso alla posizione nel suo browser, poi riprovi.",
  "requiredEmail": "È necessaria un'email valida per la ricevuta",
  "basketSaved": "Il suo carrello è salvato — le invieremo un link via email se deve andare di fretta.",
  "basketRestored": "Bentornato/a — il suo carrello è esattamente come lo ha lasciato.",
  "payWith": "Verrà reindirizzato/a su {gateway} per pagare in tutta sicurezza, poi tornerà subito qui.",
  "preauthNote": "La sua carta viene solo bloccata ora. Addebiteremo l'importo quando il suo bouquet lascerà il negozio.",
  "thankYouTitle": "Grazie — i suoi fiori sono in arrivo",
  "thankYouSub": "Abbiamo inviato la ricevuta a {email}. Il suo bouquet sta per essere assegnato al nostro team locale.",
  "newsletterOptIn": "Inviami idee floreali e offerte da Fleurinelle",
  "whatsappUpdates": "Aggiornamenti WhatsApp",
  "rescuePaid": "Il pagamento è andato a buon fine — l'ordine {n} è confermato.",
  "rescuePending": "Il pagamento non è stato completato. Non è stato ancora addebitato nulla.",
  "rescueView": "Visualizza la mia conferma",
  "rescueResume": "Completa il pagamento",
  "trackOrder": "Traccia questa consegna",
  "sendAnother": "Invia fiori a qualcun altro",
  "shareTitle": "Regala a un amico il 10% di sconto",
  "pfEmailHint": "Contatti l'assistenza per modificare il suo indirizzo email.",
  "pfSave": "Salva",
  "pfSaved": "Salvato.",
  "pfPwTitle": "Password",
  "pfCurrentPw": "Password attuale",
  "pfNewPw": "Nuova password",
  "pfPwHint": "Minimo 8 caratteri",
  "pfPwUpdated": "Password aggiornata.",
  "pfUpdatePw": "Aggiorna password",
  "pfPrivacy": "Controlli sulla privacy",
  "pfPrivacyHint": "Scarichi tutto ciò che conserviamo su di Lei, oppure elimini definitivamente il suo account. Gli ordini precedenti vengono mantenuti per obblighi contabili, ma in forma anonimizzata.",
  "pfExport": "Esporta i miei dati",
  "pfDelete": "Elimina il mio account",
  "pfDeletePrompt": "Digiti DELETE per eliminare definitivamente il suo account.",
  "prMarketing": "Marketing",
  "prUnsub": "Può annullare l'iscrizione alle comunicazioni di marketing in qualsiasi momento.",
  "prEmailOpt": "Email occasionali su nuovi bouquet e offerte",
  "prWhatsappOpt": "Offerte WhatsApp (Festa della Mamma, San Valentino, giorni festivi)",
  "prReminderOpt": "Promemoria per le occasioni speciali (compleanni, anniversari)",
  "prReminderHint": "Disattivando questa opzione si mettono in pausa tutti i promemoria del suo account.",
  "prDisplay": "Visualizzazione",
  "prLanguage": "Lingua",
  "prCurrency": "Valuta",
  "blTitle": "Indirizzo di fatturazione",
  "blNameCard": "Nome sulla carta",
  "blAddress": "Indirizzo",
  "blApt": "Interno / Piano (opzionale)",
  "blPostal": "Codice postale",
  "blCity": "Città",
  "blCountry": "Paese",
  "blChoose": "— Scegli —",
  "scTitle": "Carte salvate",
  "scBody": "Il checkout con un clic è in arrivo. Una volta attivo, le carte potranno essere salvate tramite Stripe o TRYB e utilizzate per gli ordini futuri — nessun dato relativo alle carte viene mai conservato sui server di Fleurinelle.",
  "scComingSoon": "Prossimamente",
  "accSignOut": "Esci",
  "pfPhone": "Numero di telefono",
  "pfWhatsapp": "Numero WhatsApp",
  "pfDob": "Data di nascita",
  "pfPhoneHint": "Includa il prefisso internazionale, es. +212 6 12 34 56 78",
  "pfDobHint": "Le invieremo un piccolo pensiero per il suo compleanno."
 },
 "nl": {
  "deliveryFee": "Bezorging",
  "discount": "Korting",
  "total": "Totaal",
  "continue": "Doorgaan",
  "back": "Terug",
  "backHome": "Terug naar Fleurinelle",
  "paymentNote": "Uw kaartgegevens komen nooit op de servers van Fleurinelle. De betaling verloopt via Stripe.",
  "track": "Volg uw bestelling",
  "orderNumber": "Bestelnummer",
  "trackNow": "Bekijk bestelling",
  "somethingWrong": "Er is iets misgegaan",
  "thankYou": "Dank u wel. Uw bestelling is bevestigd.",
  "whatHappensNext": "Wat gebeurt er nu",
  "viewOrder": "Bekijk bestelling",
  "currency": "Valuta",
  "language": "Taal",
  "sentFrom": "Verzonden door",
  "to": "aan",
  "readMore": "Lees meer",
  "all": "Alles",
  "loading": "Laden",
  "yearsInBusiness": "Jaar actief",
  "writeReview": "Schrijf een recensie",
  "corridorCities": "Steden waar wij bezorgen",
  "paymentMethods": "Geaccepteerde betaalmethoden",
  "company": "Bedrijf",
  "legal": "Juridisch en vertrouwen",
  "support": "WhatsApp-ondersteuning",
  "becomePartner": "Word partner",
  "becomeDriver": "Word bezorger",
  "contact": "Contact",
  "careers": "Vacatures",
  "terms": "Servicevoorwaarden",
  "privacy": "Privacybeleid",
  "cookies": "Cookiebeleid",
  "refundPolicy": "Terugbetalingsbeleid",
  "guarantee": "Bezorggarantie",
  "howItWorksLink": "Hoe het werkt",
  "cutoffIn": "Bestel binnen",
  "forDeliveryToday": "voor bezorging vandaag in",
  "closed": "Bezorging op dezelfde dag is vandaag niet meer mogelijk. De eerstvolgende bezorgdatum is al voorgeselecteerd.",
  "noResults": "Geen resultaten gevonden voor deze zoekopdracht.",
  "occasionEtiquette": "Een noot over etiquette",
  "seller": "Fleurinelle",
  "saveDate": "Herinner me volgend jaar",
  "from": "vanaf",
  "zonesLabel": "bezorgzones",
  "deliversToday": "Vandaag bezorgd",
  "closedToday": "Bezorging de volgende dag",
  "addToCart": "Voeg toe aan winkelwagen",
  "buyNow": "Doorgaan naar kassa",
  "size": "Formaat",
  "stems": "stelen",
  "addOns": "Extra's",
  "included": "Inbegrepen",
  "deliveryDetails": "Bezorging",
  "zone": "Bezorgzone",
  "date": "Bezorgdatum",
  "window": "Bezorgtijdvak",
  "morning": "Ochtend 09:00 – 13:00",
  "afternoon": "Middag 13:00 – 18:00",
  "evening": "Avond 18:00 – 21:00",
  "cardMessage": "Bericht op de kaart",
  "cardLanguage": "Taal voor handgeschreven tekst",
  "suggestions": "Voorgestelde berichten",
  "senderName": "Uw naam zoals die op de kaart verschijnt",
  "anonymous": "Anoniem, verrassingsbezorging",
  "substitution": "Vervangingsbeleid",
  "relatedProducts": "Misschien vindt u dit ook leuk",
  "checkout": "Afrekenen",
  "stepRecipient": "Ontvanger",
  "stepMessage": "Bericht en timing",
  "stepPayment": "Betaling",
  "stepConfirm": "Bevestiging",
  "fullName": "Volledige naam ontvanger",
  "phone": "Telefoonnummer ontvanger",
  "whatsapp": "WhatsApp-nummer (optioneel)",
  "address": "Volledig adres",
  "landmark": "Dichtstbijzijnd herkenningspunt of hoe de deur te vinden",
  "landmarkHelp": "Marokkaanse adressen zijn vaak beschrijvend. Dit is het nuttigste veld op deze pagina.",
  "callBefore": "Bel de ontvanger vóór bezorging",
  "callBeforeHelp": "Hoogste slagingspercentage.",
  "surprise": "Niet bellen, verrassingsbezorging",
  "surpriseHelp": "Als er niemand thuis is, belt ons team als terugvaloptie en kan herbezorging nodig zijn.",
  "buyerEmail": "Uw e-mailadres",
  "buyerPhone": "Uw telefoonnummer",
  "country": "Uw land",
  "payNow": "Veilig betalen",
  "orderSummary": "Besteloverzicht",
  "subtotal": "Subtotaal",
  "tagline": "Bloemen persoonlijk bezorgd, overal in Marokko.",
  "heroTitle": "Besteld vanuit het buitenland. Samengesteld in haar stad. Gefotografeerd aan haar deur.",
  "heroBody": "Vanochtend met de hand gemaakt in haar eigen Marokkaanse stad, nog dezelfde dag persoonlijk aan haar deur bezorgd — en een foto belandt in uw inbox, minuten nadat zij het heeft ontvangen.",
  "dealsTitle": "Deze week in de aanbieding",
  "dealsNote": "Fleurinelle-aanbiedingen, zolang de stelen strekken",
  "deliverTo": "Bezorgen aan",
  "on": "op",
  "forOccasion": "voor",
  "findFlowers": "Bloemen zoeken",
  "chooseOccasion": "Kies een gelegenheid",
  "occasions": "Gelegenheden",
  "flowers": "Bloemen",
  "cities": "Steden",
  "sameDay": "Zelfde dag",
  "about": "Over ons",
  "search": "Zoeken",
  "cart": "Winkelwagen",
  "deliveringToday": "Vandaag bezorgen in",
  "orderBefore": "bestel vóór",
  "localTime": "lokale tijd",
  "proofTitle": "U bent ver weg. Dit is wat u terugkrijgt.",
  "proofBody": "Elke Fleurinelle-bezorging wordt afgesloten met een foto genomen aan de deur, met de voornaam van de ontvangster, de stad en het exacte tijdstip van aankomst.",
  "deliveryProof": "Bezorgbewijs",
  "recipient": "Ontvangster",
  "city": "Stad",
  "deliveredAt": "Bezorgd om",
  "arrangedBy": "Samengesteld door",
  "shopByOccasion": "Winkelen op gelegenheid",
  "bestSellers": "Bestverkocht deze week",
  "howItWorks": "Hoe het werkt",
  "shopByCity": "Winkelen per stad",
  "reviews": "Beoordelingen",
  "meetFlorists": "Onze teams",
  "guides": "Gidsen",
  "faq": "Veelgestelde vragen",
  "step1Title": "Kies uw boeket in haar stad",
  "step1Body": "Geen magazijn, geen tussenpersoon. Elk boeket op deze site wordt lokaal gemaakt in de stad van de ontvangster.",
  "step2Title": "Wij beginnen binnen enkele minuten",
  "step2Body": "Zodra uw betaling is bevestigd, beginnen we met het samenstellen van het arrangement in de stad van de ontvangster. Uw bezorgvenster is vastgelegd.",
  "step3Title": "Persoonlijk bezorgd en gefotografeerd",
  "step3Body": "Bestel vóór 17:00 Marokkaanse tijd (16:30 in Agadir) voor bezorging op dezelfde dag. De foto bereikt u enkele minuten na de overdracht.",
  "trustPhoto": "Foto als bezorgbewijs",
  "trustSameDay": "Zelfde dag in vijf steden",
  "trustVetted": "Lokaal gemaakt in Marokko",
  "trustRefund": "Volledige terugbetaling als bezorging niet lukt",
  "reminderSaved": "Herinnering opgeslagen.",
  "currentlyUnavailable": "Momenteel niet beschikbaar",
  "backOnDate": "Verwacht terug op {date}",
  "backSoon": "We brengen het binnenkort terug in de winkel — kom over een paar dagen nog eens terug.",
  "restockAlertCta": "Breng me op de hoogte",
  "restockEmailPlaceholder": "Uw e-mailadres",
  "restockAlertHelp": "Eén e-mail op het moment dat het weer beschikbaar is. Geen marketing, geen delen.",
  "restockConfirm": "We sturen u een e-mail zodra dit boeket weer beschikbaar is.",
  "restockAlreadyOn": "U staat al op de lijst voor dit boeket.",
  "chooseCity": "Kies een stad",
  "addressLine1": "Adresregel 1",
  "addressLine2": "Adresregel 2",
  "buildingApartment": "Gebouw / appartement",
  "addressLine1Placeholder": "Begin met typen van de straat…",
  "addressLine2Placeholder": "Oriëntatiepunt, kruisende straat (optioneel)",
  "buildingApartmentPlaceholder": "Naam gebouw, verdieping, deur (optioneel)",
  "addressLine1Help": "We stellen automatisch Marokkaanse adressen voor terwijl u typt — selecteer er een om tijd te besparen.",
  "howOften": "Hoe vaak wilt u deze bloemen ontvangen?",
  "oneOff": "Alleen deze keer",
  "everyWeek": "Elke week",
  "everyMonth": "Elke maand",
  "everyYear": "Elk jaar",
  "ownDates": "Ik kies mijn eigen datums",
  "pickDates": "Bezorgdata",
  "addDate": "Datum toevoegen",
  "startPlan": "Plan starten",
  "planDiscount": "korting op elke bezorging bij een terugkerend abonnement",
  "planPriceLocked": "Uw prijs is vastgezet op de huidige prijs voor de gehele looptijd van het abonnement.",
  "planRouting": "Elke bezorging wordt verzorgd door ons lokale team dat die dag die zone bedient.",
  "recurringOff": "Terugkerende bezorgingen zijn beschikbaar zodra een betaalgateway is gekoppeld.",
  "mySubscriptions": "Terugkerende bezorgingen",
  "nextDelivery": "Volgende bezorging",
  "skipNext": "Sla de volgende over",
  "cancelPlan": "Abonnement opzeggen",
  "manageBilling": "Facturering beheren",
  "deliveriesSent": "bezorgingen verzonden",
  "endsAfterLast": "Stopt automatisch na de laatste datum.",
  "planCancelled": "Wordt opgezegd aan het einde van deze periode.",
  "cardSavedNote": "Uw kaart is opgeslagen en wordt de dag vóór elke gekozen datum belast.",
  "noSubscriptions": "U heeft nog geen terugkerende bezorgingen.",
  "addAnotherRecipient": "Nog een ontvanger toevoegen aan dit winkelmandje",
  "basket": "Winkelmandje",
  "giftFor": "Cadeau",
  "removeGift": "Verwijderen",
  "savedRecipients": "Opgeslagen ontvangers",
  "useSaved": "Gebruik een opgeslagen ontvanger",
  "account": "Mijn account",
  "signIn": "Inloggen",
  "signUp": "Account aanmaken",
  "signOut": "Uitloggen",
  "myOrders": "Mijn bestellingen",
  "myRecipients": "Ontvangers",
  "myReminders": "Herinneringen",
  "password": "Wachtwoord",
  "createAccount": "Account aanmaken",
  "forgotPassword": "Wachtwoord vergeten",
  "resetPassword": "Nieuw wachtwoord instellen",
  "newPassword": "Nieuw wachtwoord",
  "confirmPassword": "Nieuw wachtwoord bevestigen",
  "passwordsMismatch": "De twee wachtwoorden komen niet overeen",
  "passwordUpdated": "Uw wachtwoord is bijgewerkt",
  "saveRecipient": "Deze ontvanger opslaan",
  "addReminder": "Herinnering toevoegen",
  "remindMe": "Herinner mij",
  "leadDays": "dagen van tevoren",
  "channels": "Versturen via",
  "whatsappNumber": "WhatsApp-nummer",
  "relationship": "Wie is dit (moeder, zus, vriendin)",
  "saved": "Opgeslagen",
  "applyTitle": "Solliciteer als bezorger voor Fleurinelle",
  "applyStatus": "Uw aanmelding",
  "uploadDocuments": "Documenten",
  "submitApplication": "Aanmelding versturen",
  "shopName": "Winkelnaam",
  "ownerName": "Naam eigenaar",
  "zonesCovered": "Zones die u bedient",
  "capacity": "Bestellingen die u per dag kunt verwerken",
  "instagram": "Instagram (optioneel)",
  "notes": "Overige informatie die wij moeten weten",
  "applyCta": "Aanmelden als bloemist",
  "deliveriesInBasket": "arrangementen in dit winkelmandje",
  "createAccountPrompt": "Sla uw ontvangers op en ontvang volgend jaar een subtiele herinnering.",
  "emptyBasket": "Uw winkelmandje is leeg.",
  "accountBenefits": "Opgeslagen ontvangers, bestelgeschiedenis en jaarlijkse herinneringen.",
  "stepContact": "Contactgegevens",
  "stepDelivery": "Bezorging",
  "stepPay": "Betaling",
  "contactTitle": "Waar mogen we updates naartoe sturen?",
  "contactHelp": "Hier sturen we de bevestiging en de bezorgfoto naartoe.",
  "deliveryTitle": "Wie ontvangt de bloemen?",
  "payTitle": "Controleren en betalen",
  "haveAccount": "Log in voor opgeslagen ontvangers en sneller afrekenen",
  "returnToStore": "Terug naar de winkel",
  "editBasket": "Mandje bewerken",
  "showSummary": "Bestellingsoverzicht tonen",
  "hideSummary": "Bestellingsoverzicht verbergen",
  "addExtrasTitle": "Voeg iets toe aan deze bezorging",
  "addExtrasHelp": "Er is nog tijd — uw boeket is nog niet gemaakt. Kies een extra en we sturen het samen met de bloemen.",
  "addExtrasCta": "Toevoegen aan mijn bezorging",
  "addExtrasNote": "Apart betaald in één snelle stap. Zodra een bloemist begint met het boeket, zijn extra's niet meer beschikbaar.",
  "extrasAdded": "Uw extra is onderweg met de bloemen",
  "extrasPending": "Uw extra wordt bevestigd…",
  "basketDone": "Klaar",
  "removeLine": "Verwijderen",
  "basketEmpty": "Uw mandje is leeg.",
  "continueShopping": "Bekijk de boeketten",
  "couponQuestion": "Heeft u een kortingscode?",
  "couponPlaceholder": "Voer uw code in",
  "tickFresh": "Verse, premium bloemen",
  "tickHandTied": "Met de hand gebonden door lokale bloemisten",
  "tickOnTime": "Bezorgd binnen uw gekozen tijdslot",
  "chargedEur": "Afgerekend in EUR",
  "todaysRate": "tegen de koers van vandaag",
  "deliveringTo": "Bezorgen aan",
  "changeCity": "wijzigen",
  "couponRemove": "Verwijderen",
  "couponHint": "Typ uw code en druk op Toepassen.",
  "waQuestion": "Gebruikt de ontvanger WhatsApp op dit nummer?",
  "yes": "Ja",
  "no": "Nee",
  "waNumberLabel": "Hun WhatsApp-nummer",
  "addressQuestion": "Kent u het bezorgadres?",
  "addressKnown": "Ja, ik typ het zelf",
  "addressUnknown": "Nee — vraag het aan de ontvanger",
  "addressUnknownHelp": "We sturen hen een privélink om hun exacte locatie door te geven. Vermeld de buurt zodat de koerier alvast op weg kan.",
  "neighbourhoodRequired": "Voeg de buurt of een herkenningspunt toe voordat u betaalt.",
  "shareTheLink": "Deel de link",
  "callRequiredNote": "We bellen de ontvanger om het adres te bevestigen — een verrassingsbezorging is zonder dat niet mogelijk.",
  "applyCode": "Toepassen",
  "giftCard": "Kaartbericht",
  "charsLeft": "tekens over",
  "deliveryDate": "Bezorgdatum",
  "deliveryWindowLabel": "Tijdstip van de dag",
  "trustSecure": "Versleutelde betaling",
  "trustFlorists": "Lokaal gemaakt in Marokko",
  "shareBody": "Deel uw link. Zij besparen 10% op hun eerste boeket.",
  "upsellTitle": "Maak er een maandelijks ritueel van",
  "upsellBody": "Hetzelfde boeket, dezelfde ontvanger, elke maand — {discount}% korting op elke levering en uw prijs staat vandaag vast.",
  "upsellCta": "Stel een maandelijks abonnement in",
  "upsellWeekly": "Maak er een wekelijkse gewoonte van",
  "upsellYearly": "Eén keer per jaar",
  "createAccountTitle": "Alles op één plek bijhouden",
  "resumeExpired": "Die herstelkoppeling is verlopen — uw boeket is nog maar één tik verwijderd.",
  "expressTitle": "Snel afrekenen",
  "expressOr": "of betaal met kaart",
  "expressNote": "{wallet} opent op de beveiligde {gateway}-pagina — geen kaartgegevens typen.",
  "expressNeedInfo": "We hebben eerst de naam, het telefoonnummer en het adres van de ontvanger nodig.",
  "expressLockedLabel": "Gegevens toevoegen",
  "expressLockedNote": "Tik om de ontbrekende gegevens van de ontvanger in te vullen.",
  "accHeading": "Mijn account",
  "accBackStore": "Terug naar de winkel",
  "accFallbackTitle": "Account",
  "navOverview": "Overzicht",
  "navOrders": "Mijn bestellingen",
  "navRecurring": "Terugkerende leveringen",
  "navWishlist": "Verlanglijst",
  "navRecipients": "Ontvangers",
  "navReminders": "Herinneringen",
  "navProfile": "Profiel",
  "navPreferences": "Voorkeuren",
  "navBilling": "Factuuradres",
  "navSavedCards": "Opgeslagen kaarten",
  "ovWelcome": "Welkom terug",
  "ovLatestOrder": "Laatste bestelling",
  "ovViewOrder": "Bestelling bekijken",
  "ovNoOrders": "U heeft nog geen bestelling geplaatst.",
  "ovStartShopping": "Begin met winkelen",
  "ovNextReminder": "Volgende herinnering",
  "ovManageReminders": "Herinneringen beheren",
  "ovNoReminders": "Geen herinneringen ingesteld. We laten u op tijd weten wanneer een belangrijke datum nadert.",
  "ovAddReminder": "Herinnering toevoegen",
  "wStatOrders": "bestellingen",
  "wStatWishlist": "verlanglijstitems",
  "wStatReminders": "herinneringen",
  "wlEmpty": "Uw verlanglijst is leeg. Tik op het hartje bij een boeket om het hier op te slaan.",
  "wlBrowse": "Bekijk boeketten",
  "wlUnavailable": "Tijdelijk niet beschikbaar",
  "pfTitle": "Profiel",
  "pfFullName": "Volledige naam",
  "pfEmail": "E-mailadres",
  "trustSubstitution": "Gratis vervanging door gelijkwaardig product",
  "cutoffLead": "Bestel binnen",
  "cutoffTail": "voor bezorging vandaag in {city}",
  "cutoffClosedLead": "Bezorging op dezelfde dag in {city} is vandaag gesloten — het volgende tijdslot is morgenochtend.",
  "requiredName": "Voeg de volledige naam van de ontvanger toe",
  "requiredPhone": "Een Marokkaans mobiel nummer, bijv. +212 6 12 34 56 78",
  "requiredPhoneIntl": "Voer een geldig telefoonnummer in voor de geselecteerde landcode",
  "requiredAddress": "Straat, huisnummer en verdieping zodat ons team de deur kan vinden",
  "moroccoOnly": "Alleen bezorgd binnen Marokko",
  "mapSearchPlaceholder": "Zoek een adres in Marokko…",
  "myPosition": "Mijn locatie",
  "exactLocation": "Exacte bezorglocatie",
  "pinOnMap": "Markeer de exacte locatie",
  "pinHelp": "Help de koerier de deur te vinden — zoek het adres op of sleep de roos naar de exacte plek.",
  "pinSet": "Pin geplaatst",
  "askRecipient": "Ik weet het niet — vraag het de ontvanger",
  "askRecipientHelp": "We maken een privélink. Stuur deze naar de ontvanger; zodra zij hun locatie deelt, wordt die aan deze bestelling gekoppeld.",
  "shareLink": "Deel deze link met de ontvanger",
  "copyLink": "Link kopiëren",
  "copied": "Gekopieerd",
  "locationReceived": "Locatie ontvangen",
  "optionalLabel": "Optioneel",
  "deliverTitle": "Deel uw bezorglocatie",
  "deliverIntro": "Iemand stuurt u bloemen. Deel uw exacte locatie zodat de koerier bij de juiste deur bezorgt.",
  "shareMyLocation": "Mijn locatie delen",
  "deliverThanks": "Dank u! Uw locatie is nu gekoppeld aan de bezorging.",
  "deliverAdjust": "Sleep de roos om de exacte plek te verfijnen.",
  "deliverExpired": "Deze locatielink is niet meer geldig.",
  "enableLocation": "Sta locatietoegang toe in uw browser en probeer het opnieuw.",
  "requiredEmail": "We hebben een geldig e-mailadres nodig voor het ontvangstbewijs",
  "basketSaved": "Uw winkelmandje is opgeslagen — we sturen u een link per e-mail als u snel weg moet.",
  "basketRestored": "Welkom terug — uw winkelmandje is precies zoals u het heeft achtergelaten.",
  "payWith": "U wordt doorgestuurd naar {gateway} om veilig te betalen en keert daarna meteen terug.",
  "preauthNote": "Uw kaart wordt nu alleen geblokkeerd. We incasseren het bedrag wanneer uw boeket de winkel verlaat.",
  "thankYouTitle": "Dank u — uw bloemen zijn onderweg",
  "thankYouSub": "We hebben het ontvangstbewijs gestuurd naar {email}. Uw boeket wordt nu toegewezen aan ons lokale team.",
  "newsletterOptIn": "Stuur mij bloemenideeën en aanbiedingen van Fleurinelle",
  "whatsappUpdates": "WhatsApp-updates",
  "rescuePaid": "Uw betaling is geslaagd — bestelling {n} is bevestigd.",
  "rescuePending": "Uw betaling is niet voltooid. Er is nog niets in rekening gebracht.",
  "rescueView": "Mijn bevestiging bekijken",
  "rescueResume": "Betaling afronden",
  "trackOrder": "Deze bezorging volgen",
  "sendAnother": "Bloemen sturen naar iemand anders",
  "shareTitle": "Geef een vriend 10% korting",
  "pfEmailHint": "Neem contact op met de klantenservice om uw e-mailadres te wijzigen.",
  "pfSave": "Opslaan",
  "pfSaved": "Opgeslagen.",
  "pfPwTitle": "Wachtwoord",
  "pfCurrentPw": "Huidig wachtwoord",
  "pfNewPw": "Nieuw wachtwoord",
  "pfPwHint": "Minimaal 8 tekens",
  "pfPwUpdated": "Wachtwoord bijgewerkt.",
  "pfUpdatePw": "Wachtwoord bijwerken",
  "pfPrivacy": "Privacyinstellingen",
  "pfPrivacyHint": "Download alles wat wij over u bewaren, of verwijder uw account permanent. Eerdere bestellingen worden bewaard voor de boekhouding, maar zijn geanonimiseerd.",
  "pfExport": "Mijn gegevens exporteren",
  "pfDelete": "Mijn account verwijderen",
  "pfDeletePrompt": "Typ DELETE om uw account permanent te verwijderen.",
  "prMarketing": "Marketing",
  "prUnsub": "U kunt zich op elk moment afmelden voor marketingberichten.",
  "prEmailOpt": "Af en toe een e-mail over nieuwe boeketten en aanbiedingen",
  "prWhatsappOpt": "WhatsApp-aanbiedingen (Moederdag, Valentijnsdag, feestdagen)",
  "prReminderOpt": "Herinneringen voor speciale gelegenheden (verjaardagen, jubilea)",
  "prReminderHint": "Als u dit uitschakelt, worden alle herinneringen in uw account gepauzeerd.",
  "prDisplay": "Weergave",
  "prLanguage": "Taal",
  "prCurrency": "Valuta",
  "blTitle": "Factuuradres",
  "blNameCard": "Naam op de kaart",
  "blAddress": "Adres",
  "blApt": "Appartement / Verdieping (optioneel)",
  "blPostal": "Postcode",
  "blCity": "Stad",
  "blCountry": "Land",
  "blChoose": "— Kies —",
  "scTitle": "Opgeslagen kaarten",
  "scBody": "Afrekenen met één klik komt eraan. Wanneer ingeschakeld, kunnen kaarten worden opgeslagen via Stripe of TRYB en gebruikt worden voor toekomstige bestellingen — er worden nooit kaartgegevens opgeslagen op de servers van Fleurinelle.",
  "scComingSoon": "Binnenkort beschikbaar",
  "accSignOut": "Uitloggen",
  "pfPhone": "Telefoonnummer",
  "pfWhatsapp": "WhatsApp-nummer",
  "pfDob": "Geboortedatum",
  "pfPhoneHint": "Vermeld uw landcode, bijv. +212 6 12 34 56 78",
  "pfDobHint": "We sturen u een kleine verrassing op uw verjaardag."
 },
 "de": {
  "deliveryFee": "Lieferung",
  "discount": "Rabatt",
  "total": "Gesamt",
  "continue": "Weiter",
  "back": "Zurück",
  "backHome": "Zurück zu Fleurinelle",
  "paymentNote": "Ihre Kartendaten gelangen nie auf die Server von Fleurinelle. Die Zahlung wird über Stripe abgewickelt.",
  "track": "Ihre Bestellung verfolgen",
  "orderNumber": "Bestellnummer",
  "trackNow": "Bestellung anzeigen",
  "somethingWrong": "Es ist ein Fehler aufgetreten",
  "thankYou": "Vielen Dank. Ihre Bestellung ist bestätigt.",
  "whatHappensNext": "Wie geht es weiter",
  "viewOrder": "Bestellung anzeigen",
  "currency": "Währung",
  "language": "Sprache",
  "sentFrom": "Gesendet von",
  "to": "an",
  "readMore": "Mehr erfahren",
  "all": "Alle",
  "loading": "Wird geladen",
  "yearsInBusiness": "Jahre am Markt",
  "writeReview": "Bewertung schreiben",
  "corridorCities": "Städte, in die wir liefern",
  "paymentMethods": "Akzeptierte Zahlungsmethoden",
  "company": "Unternehmen",
  "legal": "Rechtliches und Vertrauen",
  "support": "WhatsApp-Support",
  "becomePartner": "Partner werden",
  "becomeDriver": "Fahrer werden",
  "contact": "Kontakt",
  "careers": "Karriere",
  "terms": "Allgemeine Geschäftsbedingungen",
  "privacy": "Datenschutzrichtlinie",
  "cookies": "Cookie-Richtlinie",
  "refundPolicy": "Rückerstattungsrichtlinie",
  "guarantee": "Liefergarantie",
  "howItWorksLink": "So funktioniert es",
  "cutoffIn": "Jetzt bestellen innerhalb von",
  "forDeliveryToday": "für die heutige Lieferung nach",
  "closed": "Die Lieferung am selben Tag ist für heute nicht mehr möglich. Das nächste Lieferdatum ist bereits vorausgewählt.",
  "noResults": "Für diese Suche wurden keine Ergebnisse gefunden.",
  "occasionEtiquette": "Ein Hinweis zur Etikette",
  "seller": "Fleurinelle",
  "saveDate": "Nächstes Jahr erinnern",
  "from": "ab",
  "zonesLabel": "Lieferzonen",
  "deliversToday": "Heute lieferbar",
  "closedToday": "Lieferung am nächsten Tag",
  "addToCart": "In den Warenkorb",
  "buyNow": "Weiter zur Kasse",
  "size": "Größe",
  "stems": "Stiele",
  "addOns": "Extras",
  "included": "Inklusive",
  "deliveryDetails": "Lieferung",
  "zone": "Lieferzone",
  "date": "Lieferdatum",
  "window": "Lieferzeitfenster",
  "morning": "Vormittag 09:00 – 13:00",
  "afternoon": "Nachmittag 13:00 – 18:00",
  "evening": "Abend 18:00 – 21:00",
  "cardMessage": "Nachricht auf der Karte",
  "cardLanguage": "Sprache der Handschrift",
  "suggestions": "Nachrichtenvorschläge",
  "senderName": "Ihr Name, wie er auf der Karte erscheint",
  "anonymous": "Anonym, Überraschungslieferung",
  "substitution": "Ersatzrichtlinie",
  "relatedProducts": "Das könnte Ihnen auch gefallen",
  "checkout": "Kasse",
  "stepRecipient": "Empfänger",
  "stepMessage": "Nachricht und Zeitpunkt",
  "stepPayment": "Zahlung",
  "stepConfirm": "Bestätigung",
  "fullName": "Vollständiger Name des Empfängers",
  "phone": "Telefon des Empfängers",
  "whatsapp": "WhatsApp-Nummer (optional)",
  "address": "Vollständige Adresse",
  "landmark": "Nächster Orientierungspunkt oder Wegbeschreibung zur Tür",
  "landmarkHelp": "Marokkanische Adressen sind oft beschreibender Natur. Dies ist das nützlichste Feld auf dieser Seite.",
  "callBefore": "Empfänger vor der Lieferung anrufen",
  "callBeforeHelp": "Höchste Erfolgsquote.",
  "surprise": "Nicht anrufen, Überraschungslieferung",
  "surpriseHelp": "Wenn niemand zu Hause ist, ruft unser Team als Rückfalloption an, und eine erneute Lieferung kann erforderlich sein.",
  "buyerEmail": "Ihre E-Mail-Adresse",
  "buyerPhone": "Ihre Telefonnummer",
  "country": "Ihr Land",
  "payNow": "Sicher bezahlen",
  "orderSummary": "Bestellübersicht",
  "subtotal": "Zwischensumme",
  "tagline": "Blumen persönlich zugestellt, überall in Marokko.",
  "heroTitle": "Bestellt aus dem Ausland. Arrangiert in ihrer Stadt. Fotografiert an ihrer Tür.",
  "heroBody": "Heute Morgen in ihrer eigenen marokkanischen Stadt handgefertigt, noch am selben Tag persönlich an ihre Tür gebracht — und ein Foto landet in Ihrem Posteingang, wenige Minuten nachdem sie es erhalten hat.",
  "dealsTitle": "Diese Woche im Angebot",
  "dealsNote": "Fleurinelle-Aktionen, solange der Vorrat reicht",
  "deliverTo": "Liefern an",
  "on": "am",
  "forOccasion": "für",
  "findFlowers": "Blumen finden",
  "chooseOccasion": "Anlass wählen",
  "occasions": "Anlässe",
  "flowers": "Blumen",
  "cities": "Städte",
  "sameDay": "Am selben Tag",
  "about": "Über uns",
  "search": "Suchen",
  "cart": "Warenkorb",
  "deliveringToday": "Heute liefern in",
  "orderBefore": "bestellen bis",
  "localTime": "Ortszeit",
  "proofTitle": "Sie sind weit weg. Das bekommen Sie zurück.",
  "proofBody": "Jede Fleurinelle-Lieferung endet mit einem Foto, das an der Tür aufgenommen wird — mit dem Vornamen der Empfängerin, der Stadt und der genauen Ankunftszeit.",
  "deliveryProof": "Liefernachweis",
  "recipient": "Empfängerin",
  "city": "Stadt",
  "deliveredAt": "Zugestellt um",
  "arrangedBy": "Arrangiert von",
  "shopByOccasion": "Nach Anlass einkaufen",
  "bestSellers": "Bestseller dieser Woche",
  "howItWorks": "So funktioniert es",
  "shopByCity": "Nach Stadt einkaufen",
  "reviews": "Bewertungen",
  "meetFlorists": "Unsere Teams",
  "guides": "Ratgeber",
  "faq": "Häufig gestellte Fragen",
  "step1Title": "Wählen Sie den Strauß in ihrer Stadt",
  "step1Body": "Kein Lager, kein Zwischenhändler. Jeder Strauß auf dieser Website wird lokal in der Stadt der Empfängerin gefertigt.",
  "step2Title": "Wir beginnen in wenigen Minuten",
  "step2Body": "Sobald Ihre Zahlung bestätigt ist, beginnen wir mit dem Arrangieren in der Stadt der Empfängerin. Ihr Lieferfenster ist damit festgelegt.",
  "step3Title": "Persönlich zugestellt und fotografiert",
  "step3Body": "Bestellen Sie bis 17:00 Uhr marokkanischer Zeit (16:30 Uhr in Agadir) für die Lieferung am selben Tag. Das Foto erreicht Sie wenige Minuten nach der Übergabe.",
  "trustPhoto": "Foto als Liefernachweis",
  "trustSameDay": "Am selben Tag in fünf Städten",
  "trustVetted": "Lokal in Marokko gefertigt",
  "trustRefund": "Vollständige Rückerstattung, falls wir nicht liefern können",
  "reminderSaved": "Erinnerung gespeichert.",
  "currentlyUnavailable": "Derzeit nicht verfügbar",
  "backOnDate": "Voraussichtlich wieder verfügbar am {date}",
  "backSoon": "Wir bringen es bald wieder in den Shop — schauen Sie in ein paar Tagen nochmals vorbei.",
  "restockAlertCta": "Benachrichtigen",
  "restockEmailPlaceholder": "Ihre E-Mail-Adresse",
  "restockAlertHelp": "Eine einzige E-Mail, sobald es wieder verfügbar ist. Kein Marketing, keine Weitergabe.",
  "restockConfirm": "Wir benachrichtigen Sie per E-Mail, sobald dieser Strauß wieder verfügbar ist.",
  "restockAlreadyOn": "Sie stehen bereits auf der Warteliste für diesen Strauß.",
  "chooseCity": "Stadt auswählen",
  "addressLine1": "Adresszeile 1",
  "addressLine2": "Adresszeile 2",
  "buildingApartment": "Gebäude / Wohnung",
  "addressLine1Placeholder": "Straße eingeben…",
  "addressLine2Placeholder": "Orientierungspunkt, Querstraße (optional)",
  "buildingApartmentPlaceholder": "Gebäudename, Etage, Tür (optional)",
  "addressLine1Help": "Während Sie tippen, schlagen wir automatisch marokkanische Adressen vor — wählen Sie einfach eine aus.",
  "howOften": "Wie oft sollen diese Blumen geliefert werden?",
  "oneOff": "Nur dieses Mal",
  "everyWeek": "Jede Woche",
  "everyMonth": "Jeden Monat",
  "everyYear": "Jedes Jahr",
  "ownDates": "Ich wähle meine eigenen Termine",
  "pickDates": "Liefertermine",
  "addDate": "Termin hinzufügen",
  "startPlan": "Abo starten",
  "planDiscount": "Rabatt auf jede Lieferung bei einem Abonnement",
  "planPriceLocked": "Ihr Preis ist für die gesamte Laufzeit des Abos zum heutigen Preis festgeschrieben.",
  "planRouting": "Jede Lieferung wird von unserem lokalen Team übernommen, das an dem jeweiligen Tag die entsprechende Zone betreut.",
  "recurringOff": "Wiederkehrende Lieferungen werden freigeschaltet, sobald ein Zahlungsanbieter verknüpft ist.",
  "mySubscriptions": "Wiederkehrende Lieferungen",
  "nextDelivery": "Nächste Lieferung",
  "skipNext": "Nächste überspringen",
  "cancelPlan": "Abo kündigen",
  "manageBilling": "Abrechnung verwalten",
  "deliveriesSent": "Lieferungen versendet",
  "endsAfterLast": "Endet automatisch nach dem letzten Termin.",
  "planCancelled": "Wird am Ende dieses Zeitraums gekündigt.",
  "cardSavedNote": "Ihre Karte ist gespeichert und wird jeweils einen Tag vor dem gewählten Termin belastet.",
  "noSubscriptions": "Sie haben noch keine wiederkehrenden Lieferungen.",
  "addAnotherRecipient": "Einen weiteren Empfänger zu diesem Warenkorb hinzufügen",
  "basket": "Warenkorb",
  "giftFor": "Geschenk",
  "removeGift": "Entfernen",
  "savedRecipients": "Gespeicherte Empfänger",
  "useSaved": "Gespeicherten Empfänger verwenden",
  "account": "Mein Konto",
  "signIn": "Anmelden",
  "signUp": "Konto erstellen",
  "signOut": "Abmelden",
  "myOrders": "Meine Bestellungen",
  "myRecipients": "Empfänger",
  "myReminders": "Erinnerungen",
  "password": "Passwort",
  "createAccount": "Konto erstellen",
  "forgotPassword": "Passwort vergessen",
  "resetPassword": "Neues Passwort festlegen",
  "newPassword": "Neues Passwort",
  "confirmPassword": "Neues Passwort bestätigen",
  "passwordsMismatch": "Die beiden Passwörter stimmen nicht überein",
  "passwordUpdated": "Ihr Passwort wurde aktualisiert",
  "saveRecipient": "Diesen Empfänger speichern",
  "addReminder": "Erinnerung hinzufügen",
  "remindMe": "Erinnere mich",
  "leadDays": "Tage vorher",
  "channels": "Senden per",
  "whatsappNumber": "WhatsApp-Nummer",
  "relationship": "Wer ist das (Mutter, Schwester, Freundin)",
  "saved": "Gespeichert",
  "applyTitle": "Als Zusteller für Fleurinelle bewerben",
  "applyStatus": "Ihre Bewerbung",
  "uploadDocuments": "Dokumente",
  "submitApplication": "Bewerbung einreichen",
  "shopName": "Geschäftsname",
  "ownerName": "Name des Inhabers",
  "zonesCovered": "Gebiete, die Sie abdecken",
  "capacity": "Bestellungen, die Sie pro Tag bearbeiten können",
  "instagram": "Instagram (optional)",
  "notes": "Weitere Informationen, die wir wissen sollten",
  "applyCta": "Als Florist bewerben",
  "deliveriesInBasket": "Arrangements in diesem Warenkorb",
  "createAccountPrompt": "Speichern Sie Ihre Empfänger und erhalten Sie nächstes Jahr eine diskrete Erinnerung.",
  "emptyBasket": "Ihr Warenkorb ist leer.",
  "accountBenefits": "Gespeicherte Empfänger, Bestellhistorie und jährliche Erinnerungen.",
  "stepContact": "Kontakt",
  "stepDelivery": "Lieferung",
  "stepPay": "Zahlung",
  "contactTitle": "Wohin sollen wir Updates senden?",
  "contactHelp": "Hier senden wir die Quittung und das Lieferfoto.",
  "deliveryTitle": "Wer empfängt die Blumen?",
  "payTitle": "Prüfen und bezahlen",
  "haveAccount": "Melden Sie sich an, um gespeicherte Empfänger zu nutzen und schneller zur Kasse zu gehen",
  "returnToStore": "Zurück zum Shop",
  "editBasket": "Warenkorb bearbeiten",
  "showSummary": "Bestellübersicht anzeigen",
  "hideSummary": "Bestellübersicht ausblenden",
  "addExtrasTitle": "Etwas zu dieser Lieferung hinzufügen",
  "addExtrasHelp": "Es ist noch Zeit — Ihr Strauß wurde noch nicht gebunden. Wählen Sie ein Extra aus und wir schicken es zusammen mit den Blumen.",
  "addExtrasCta": "Zu meiner Lieferung hinzufügen",
  "addExtrasNote": "Separat in einem schnellen Schritt bezahlt. Sobald ein Florist mit dem Strauß beginnt, sind keine Extras mehr möglich.",
  "extrasAdded": "Ihr Extra ist zusammen mit den Blumen unterwegs",
  "extrasPending": "Ihr Extra wird bestätigt…",
  "basketDone": "Fertig",
  "removeLine": "Entfernen",
  "basketEmpty": "Ihr Warenkorb ist leer.",
  "continueShopping": "Sträuße entdecken",
  "couponQuestion": "Haben Sie einen Gutscheincode?",
  "couponPlaceholder": "Code eingeben",
  "tickFresh": "Frische Premium-Blumen",
  "tickHandTied": "Von lokalen Floristen handgebunden",
  "tickOnTime": "Geliefert in Ihrem gewählten Zeitfenster",
  "chargedEur": "Abgerechnet in EUR",
  "todaysRate": "zum heutigen Kurs",
  "deliveringTo": "Lieferung an",
  "changeCity": "ändern",
  "couponRemove": "Entfernen",
  "couponHint": "Geben Sie Ihren Code ein und klicken Sie auf Einlösen.",
  "waQuestion": "Nutzt der Empfänger WhatsApp auf dieser Nummer?",
  "yes": "Ja",
  "no": "Nein",
  "waNumberLabel": "Ihre WhatsApp-Nummer",
  "addressQuestion": "Kennen Sie die Lieferadresse?",
  "addressKnown": "Ja, ich gebe sie ein",
  "addressUnknown": "Nein — Empfänger fragen",
  "addressUnknownHelp": "Wir senden ihnen einen privaten Link, damit sie ihren genauen Standort angeben können. Nennen Sie uns das Viertel, damit der Kurier sich auf den Weg machen kann.",
  "neighbourhoodRequired": "Bitte geben Sie vor der Zahlung das Viertel oder einen Orientierungspunkt an.",
  "shareTheLink": "Link teilen",
  "callRequiredNote": "Wir rufen den Empfänger an, um die Adresse zu bestätigen — eine Überraschungslieferung ist ohne diese Angabe nicht möglich.",
  "applyCode": "Einlösen",
  "giftCard": "Grußkarte",
  "charsLeft": "Zeichen übrig",
  "deliveryDate": "Lieferdatum",
  "deliveryWindowLabel": "Tageszeit",
  "trustSecure": "Verschlüsselte Zahlung",
  "trustFlorists": "Lokal hergestellt in Marokko",
  "shareBody": "Teilen Sie Ihren Link. Damit sparen Ihre Freunde 10% auf ihr erstes Bouquet.",
  "upsellTitle": "Machen Sie es zu einem monatlichen Ritual",
  "upsellBody": "Dasselbe Bouquet, dieselbe Empfängerin, jeden Monat — {discount}% Rabatt auf jede Lieferung und Ihr Preis wird heute festgeschrieben.",
  "upsellCta": "Monatlichen Plan einrichten",
  "upsellWeekly": "Wöchentlich liefern lassen",
  "upsellYearly": "Einmal im Jahr",
  "createAccountTitle": "Alles an einem Ort im Blick behalten",
  "resumeExpired": "Dieser Wiederherstellungslink ist abgelaufen — Ihr Bouquet ist nur noch einen Tipp entfernt.",
  "expressTitle": "Express-Checkout",
  "expressOr": "oder mit Karte bezahlen",
  "expressNote": "{wallet} öffnet sich auf der sicheren {gateway}-Seite — keine Kartendaten eingeben.",
  "expressNeedInfo": "Wir benötigen zunächst Name, Telefonnummer und Adresse der Empfängerin.",
  "expressLockedLabel": "Details hinzufügen",
  "expressLockedNote": "Tippen Sie hier, um die noch fehlenden Angaben zur Empfängerin einzutragen.",
  "accHeading": "Mein Konto",
  "accBackStore": "Zurück zum Shop",
  "accFallbackTitle": "Konto",
  "navOverview": "Übersicht",
  "navOrders": "Meine Bestellungen",
  "navRecurring": "Wiederkehrende Lieferungen",
  "navWishlist": "Wunschliste",
  "navRecipients": "Empfänger",
  "navReminders": "Erinnerungen",
  "navProfile": "Profil",
  "navPreferences": "Einstellungen",
  "navBilling": "Rechnungsadresse",
  "navSavedCards": "Gespeicherte Karten",
  "ovWelcome": "Willkommen zurück",
  "ovLatestOrder": "Letzte Bestellung",
  "ovViewOrder": "Bestellung ansehen",
  "ovNoOrders": "Sie haben noch keine Bestellung aufgegeben.",
  "ovStartShopping": "Jetzt einkaufen",
  "ovNextReminder": "Nächste Erinnerung",
  "ovManageReminders": "Erinnerungen verwalten",
  "ovNoReminders": "Keine Erinnerungen eingerichtet. Wir benachrichtigen Sie rechtzeitig vor jedem wichtigen Datum.",
  "ovAddReminder": "Erinnerung hinzufügen",
  "wStatOrders": "Bestellungen",
  "wStatWishlist": "Wunschlistenartikel",
  "wStatReminders": "Erinnerungen",
  "wlEmpty": "Ihre Wunschliste ist leer. Tippen Sie auf das Herz bei einem Bouquet, um es hier zu speichern.",
  "wlBrowse": "Bouquets entdecken",
  "wlUnavailable": "Vorübergehend nicht verfügbar",
  "pfTitle": "Profil",
  "pfFullName": "Vollständiger Name",
  "pfEmail": "E-Mail-Adresse",
  "trustSubstitution": "Kostenloser Ersatz durch gleichwertiges Produkt",
  "cutoffLead": "Bestellen Sie innerhalb von",
  "cutoffTail": "für die Lieferung heute in {city}",
  "cutoffClosedLead": "Die Lieferung am selben Tag in {city} ist für heute geschlossen — der nächste Slot ist morgen früh.",
  "requiredName": "Bitte fügen Sie den vollständigen Namen des Empfängers hinzu",
  "requiredPhone": "Eine marokkanische Handynummer, z. B. +212 6 12 34 56 78",
  "requiredPhoneIntl": "Bitte geben Sie eine gültige Telefonnummer für die gewählte Ländervorwahl ein",
  "requiredAddress": "Straße, Hausnummer und Wohnung, damit unser Team die Tür findet",
  "moroccoOnly": "Lieferung ausschließlich innerhalb Marokkos",
  "mapSearchPlaceholder": "Adresse in Marokko suchen…",
  "myPosition": "Mein Standort",
  "exactLocation": "Genaue Lieferadresse",
  "pinOnMap": "Genauen Standort markieren",
  "pinHelp": "Helfen Sie dem Kurier, die Tür zu finden — suchen Sie die Adresse oder ziehen Sie die Rose an die genaue Stelle.",
  "pinSet": "Markierung gesetzt",
  "askRecipient": "Ich weiß es nicht — Empfänger fragen",
  "askRecipientHelp": "Wir erstellen einen privaten Link. Senden Sie ihn an den Empfänger; sobald dieser seinen Standort teilt, wird er mit dieser Bestellung verknüpft.",
  "shareLink": "Diesen Link mit dem Empfänger teilen",
  "copyLink": "Link kopieren",
  "copied": "Kopiert",
  "locationReceived": "Standort empfangen",
  "optionalLabel": "Optional",
  "deliverTitle": "Teilen Sie Ihren Lieferstandort",
  "deliverIntro": "Jemand schickt Ihnen Blumen. Teilen Sie Ihren genauen Standort, damit der Kurier an der richtigen Tür liefert.",
  "shareMyLocation": "Meinen Standort teilen",
  "deliverThanks": "Vielen Dank! Ihr Standort ist jetzt mit der Lieferung verknüpft.",
  "deliverAdjust": "Ziehen Sie die Rose, um den genauen Punkt feinzujustieren.",
  "deliverExpired": "Dieser Standortlink ist nicht mehr gültig.",
  "enableLocation": "Bitte erlauben Sie den Standortzugriff in Ihrem Browser und versuchen Sie es erneut.",
  "requiredEmail": "Wir benötigen eine gültige E-Mail-Adresse für die Quittung",
  "basketSaved": "Ihr Warenkorb ist gespeichert — wir schicken Ihnen per E-Mail einen Link, falls Sie schnell gehen müssen.",
  "basketRestored": "Willkommen zurück — Ihr Warenkorb ist genau so, wie Sie ihn verlassen haben.",
  "payWith": "Sie werden zu {gateway} weitergeleitet, um sicher zu zahlen, und kommen danach sofort zurück.",
  "preauthNote": "Ihre Karte wird jetzt nur reserviert. Den Betrag buchen wir ab, wenn Ihr Blumenstrauß das Geschäft verlässt.",
  "thankYouTitle": "Vielen Dank — Ihre Blumen sind auf dem Weg",
  "thankYouSub": "Wir haben die Quittung an {email} gesendet. Ihr Blumenstrauß wird gerade unserem lokalen Team zugewiesen.",
  "newsletterOptIn": "Senden Sie mir Blumenideen und Angebote von Fleurinelle",
  "whatsappUpdates": "WhatsApp-Updates",
  "rescuePaid": "Ihre Zahlung war erfolgreich — Bestellung {n} ist bestätigt.",
  "rescuePending": "Ihre Zahlung wurde nicht abgeschlossen. Es wurde noch nichts belastet.",
  "rescueView": "Meine Bestätigung ansehen",
  "rescueResume": "Zahlung abschließen",
  "trackOrder": "Diese Lieferung verfolgen",
  "sendAnother": "Blumen an jemand anderen senden",
  "shareTitle": "Schenken Sie einem Freund 10% Rabatt",
  "pfEmailHint": "Wenden Sie sich an den Support, um Ihre E-Mail-Adresse zu ändern.",
  "pfSave": "Speichern",
  "pfSaved": "Gespeichert.",
  "pfPwTitle": "Passwort",
  "pfCurrentPw": "Aktuelles Passwort",
  "pfNewPw": "Neues Passwort",
  "pfPwHint": "Mindestens 8 Zeichen",
  "pfPwUpdated": "Passwort aktualisiert.",
  "pfUpdatePw": "Passwort aktualisieren",
  "pfPrivacy": "Datenschutzeinstellungen",
  "pfPrivacyHint": "Laden Sie alle Daten herunter, die wir über Sie gespeichert haben, oder löschen Sie Ihr Konto dauerhaft. Frühere Bestellungen werden aus buchhalterischen Gründen aufbewahrt, jedoch anonymisiert.",
  "pfExport": "Meine Daten exportieren",
  "pfDelete": "Mein Konto löschen",
  "pfDeletePrompt": "Geben Sie DELETE ein, um Ihr Konto dauerhaft zu löschen.",
  "prMarketing": "Marketing",
  "prUnsub": "Sie können sich jederzeit von Marketing-Mitteilungen abmelden.",
  "prEmailOpt": "Gelegentliche E-Mails zu neuen Sträußen und Angeboten",
  "prWhatsappOpt": "WhatsApp-Angebote (Muttertag, Valentinstag, Feiertage)",
  "prReminderOpt": "Erinnerungen für besondere Anlässe (Geburtstage, Jahrestage)",
  "prReminderHint": "Wenn Sie dies deaktivieren, werden alle Erinnerungen in Ihrem Konto pausiert.",
  "prDisplay": "Anzeige",
  "prLanguage": "Sprache",
  "prCurrency": "Währung",
  "blTitle": "Rechnungsadresse",
  "blNameCard": "Name auf der Karte",
  "blAddress": "Adresse",
  "blApt": "Wohnung / Etage (optional)",
  "blPostal": "Postleitzahl",
  "blCity": "Stadt",
  "blCountry": "Land",
  "blChoose": "— Auswählen —",
  "scTitle": "Gespeicherte Karten",
  "scBody": "Ein-Klick-Checkout ist in Kürze verfügbar. Sobald aktiviert, können Karten über Stripe oder TRYB gespeichert und für zukünftige Bestellungen verwendet werden — kartenbezogene Daten werden niemals auf den Servern von Fleurinelle gespeichert.",
  "scComingSoon": "Demnächst verfügbar",
  "accSignOut": "Abmelden",
  "pfPhone": "Telefonnummer",
  "pfWhatsapp": "WhatsApp-Nummer",
  "pfDob": "Geburtsdatum",
  "pfPhoneHint": "Bitte geben Sie Ihre Ländervorwahl an, z. B. +212 6 12 34 56 78",
  "pfDobHint": "Wir schicken Ihnen zu Ihrem Geburtstag eine kleine Überraschung."
 }
};
export default MORE;
